<template>
<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>운송보험</li>
					<li>보상내용</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>보상내용</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<div class="conStyle1">
						<p class="tit mgt0">보상하는 손해</p>
						<ol class="num">
							<li>
								전 위험 담보
								<ul class="line">
									<li>보험에 가입한 물건이 육상(호수와 하천을 포함)에서 운송하는 도중에 생긴 모든 손해</li>
								</ul>
							</li>
							<li>
								전손 및 분손 담보
								<ul class="line">
									<li>운송용구의 탈선, 전복, 추락, 화재, 폭발 또는 충돌로 생긴 보험 목적의 전부 손해 및 일부 손해</li>
									<li>하역 또는 이적 중에 보험 목적의 추락으로 생긴 포장당 전부 손해 및 일부 손해</li>
								</ul>
							</li>
							<li>
								전손 담보
								<ul class="line">
									<li>운송용구의 탈선, 전복, 추락, 화재, 폭발 또는 충돌로 생긴 보험 목적의 전부 손해</li>
									<li>하역 또는 이적 중에 보험 목적의 추락으로 생긴 포장당 전부 손해</li>
								</ul>
							</li>
						</ol>

						<p class="tit">보상하지 않는 손해</p>
						<ol class="num">
							<li><br>
								<ul class="line">
									<li>계약자, 피보험자, 이들의 대리인이나 사용인의 고의 또는 중대한 과실</li>
									<li>화물의 흠, 자연적인 소모 또는 성질로 인한 발화, 폭발, 뜸, 곰팡이, 부패, 변색, 녹</li>
									<li>포장의 불완전</li>
									<li>운송의 지연</li>
									<li>핵연료 및 방사선에 의한 손해</li>
									<li>전쟁으로 인한 손해</li>
									<li>이사 화물 중 독, 항아리, 병 등의 파손 및 이에 수용한 유동품의 멸실</li>
								</ul>
							</li>
							<li><br>
								<ul class="line">
									<li>동맹파업, 태업, 작업장 폐쇄, 쟁의행위, 폭동, 소요</li>
									<li>억류, 압류</li>
									<li>지진(지진에 의한 해일 포함), 분화</li>
									<li>실외 및 옥외에 쌓여있거나 덮개없는 차, 완전히 덮혀지지 않은 운송용구에 적재된 경우 (덮개있는 차, 완전히 덮혀진 운송용구에 적재했더라도 발생되었을 손해는 보상함)</li>
									<li>자기화물을 자기소유의 차량으로 운송하는 도중 생긴 손해</li>
									<li>냉동장비, 냉장기계, 기타 부속기구 및 이를 작동시키는 동력기구의 파손이나 고장으로 생긴 손해</li>
								</ul>
							</li>
						</ol>
						<p class="txt">※ 2번 면책사항의 경우, 특별약관으로 별도 약정하여 보상 가능함.</p>
					</div>
				</div>
			</div>
		</div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import util from '@/common/util'
import { sessionUserInfo, load } from '@/common/sessionFactory'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'

</script>

<style>

</style>
